// @flow

import { AUTH_SECCESS, AUTH_ERROR, AUTH_IN_PROGRESS } from '../actions/actionTypes';
import { overrideObjectWithEmptyProperty } from '../../core/ReduxUtils';

const INITIAL_STATE = {
  layoutStaticData: {},
  authenticationError: false,
  authenticationSuccess: false,
  authenticationInProgress: false,
};

export default function authReducer(state = INITIAL_STATE, action = {}) {
  function authInProgress() {
    return {
      ...state,
      authenticationError: false,
      authenticationSuccess: false,
      authenticationInProgress: true,
    };
  }
  function authSuccess() {
    return {
      ...state,
      authenticationError: false,
      authenticationSuccess: true,
      authenticationInProgress: false,
    };
  }
  function authError() {
    const layoutStaticData = overrideObjectWithEmptyProperty({
      ...state.layoutStaticData,
      ...action.layoutStaticData,
    });

    return {
      ...state,
      layoutStaticData,
      authenticationError: true,
      authenticationSuccess: false,
      authenticationInProgress: false,
    };
  }

  switch (action.type) {
    case AUTH_IN_PROGRESS:
      return authInProgress();
    case AUTH_SECCESS:
      return authSuccess();
    case AUTH_ERROR:
      return authError();
    default:
      return state;
  }
}
